// extracted by css-extract-rspack-plugin
export default {"BaseCell":"sub-issues-progress-renderer-module__BaseCell__mUn4G5p","ButtonBase":"sub-issues-progress-renderer-module__ButtonBase__BV6eDMq"};